import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  TextInput,
  Button,
  SimpleGrid,
  Center,
  Group,
  Space,
  PasswordInput,
  Title,
} from '@mantine/core';

const Settings = () => {
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    siteId: '',
    siteName: '',
    siteNameArabic: '',
    comPortNumber: '',
    lat: '',
    long: '',
  });
  const [passwordVerify, setPasswordVerify] = useState('');
  const [isEdit, setIsEdit] = useState(false);

  const password = 'admin@kiosk';

  useEffect(() => {
    const savedSiteDetails = JSON.parse(localStorage.getItem('siteDetails')) || {};
    setInitialValues(savedSiteDetails);
  }, []);

  const submitForm = () => {
    localStorage.setItem('siteDetails', JSON.stringify(initialValues));
    navigate('/');
  };

  const handleInputChange = (field) => (event) => {
    setInitialValues((prevState) => ({
      ...prevState,
      [field]: event.target.value,
    }));
  };

  const renderTextInput = (label, placeholder, value, onChange, disabled = false) => (
    <TextInput
      placeholder={placeholder}
      label={label}
      value={value}
      onChange={onChange}
      withAsterisk
      disabled={disabled}
    />
  );

  return (
    <Box>
      <Center>
        <Title order={1}>Configure Site Details</Title>
      </Center>
      <Space h="xl" />

      {isEdit ? (
        <Box>
          <SimpleGrid cols={2}>
            {renderTextInput(
              'Site Id',
              'Enter Site Id',
              initialValues.siteId,
              handleInputChange('siteId'),
            )}
            {renderTextInput(
              'Site Name',
              'Enter Site Name',
              initialValues.siteName,
              handleInputChange('siteName'),
            )}
            {renderTextInput(
              'Longitude',
              'Enter Longitude',
              initialValues.long,
              handleInputChange('long'),
            )}
            {renderTextInput(
              'Latitude',
              'Enter Latitude',
              initialValues.lat,
              handleInputChange('lat'),
            )}
            {renderTextInput(
              'Site Name Arabic',
              'Enter Site Name Arabic',
              initialValues.siteNameArabic,
              handleInputChange('siteNameArabic'),
            )}
            {renderTextInput(
              'Com Port',
              'Enter Com Port',
              initialValues.comPortNumber,
              handleInputChange('comPortNumber'),
            )}
          </SimpleGrid>

          <Space h="xl" />

          <SimpleGrid cols={2}>
            <PasswordInput
              placeholder="Enter Kiosk Unique Code"
              label="Kiosk Unique Code"
              value={passwordVerify}
              onChange={(e) => setPasswordVerify(e.target.value)}
            />
            <PasswordInput
              placeholder="Enter Password"
              label="Password"
              value={passwordVerify}
              onChange={(e) => setPasswordVerify(e.target.value)}
            />
          </SimpleGrid>
        </Box>
      ) : (
        <Box>
          {initialValues ? (
            <SimpleGrid cols={2}>
              {renderTextInput('Site Id', 'Enter Site Id', initialValues.siteId, () => {}, true)}
              {renderTextInput(
                'Site Name',
                'Enter Site Name',
                initialValues.siteName,
                () => {},
                true,
              )}
              {renderTextInput('Longitude', 'Enter Longitude', initialValues.long, () => {}, true)}
              {renderTextInput('Latitude', 'Enter Latitude', initialValues.lat, () => {}, true)}
              {renderTextInput(
                'Site Name Arabic',
                'Enter Site Name Arabic',
                initialValues.siteNameArabic,
                () => {},
                true,
              )}
              {renderTextInput(
                'Com Port',
                'Enter Com Port',
                initialValues.comPortNumber,
                () => {},
                true,
              )}
            </SimpleGrid>
          ) : null}
        </Box>
      )}

      <Space h="xl" />
      <Center>
        <Group>
          <Button onClick={() => navigate('/')} size="md">
            Home
          </Button>
          <Button onClick={() => setIsEdit(true)} size="md">
            Reset Configuration
          </Button>
          {isEdit && (
            <>
              <Button onClick={() => setIsEdit(false)} size="md">
                Cancel
              </Button>
              <Button
                onClick={submitForm}
                disabled={password !== passwordVerify}
                size="md"
                color="blue"
              >
                Save
              </Button>
            </>
          )}
        </Group>
      </Center>
    </Box>
  );
};

export default Settings;
